import GamesRecordResultContent from "../GamesRecordResultContent";
import GamesSuccessResultContent from "../GamesSuccessResultContent";
import GamesResultsBottomBar from "../../../bars/games/GamesResultsBottomBar";
import GamesResultsLayout from "../../../layouts/games/GamesResultsLayout";
import GamesLooseResultContent from "../GamesLooseResultContent";
import {kRelativeDifferenceLists} from "../../../../constants/lists";
import {kGamesNumbers} from "../../../../constants/numbers";

export default function RelativeDifferenceResults({isLost, finalScore, lastRelativeDifference, lastAnswer, onRetryPressed}) {
    // Used in MultiplicationGameScreen to display loose, success of
    // record related content

    // BUILD
    return (
        <div className={"animate-appearSlow bg-backgroundLight3 w-full h-full flex flex-col justify-center items-center"}>
            <GamesResultsLayout>
                {isLost
                    ? <GamesLooseResultContent
                        lastQuestion={lastRelativeDifference}
                        finalScore={finalScore}
                        lastAnswer={lastAnswer}
                        advicesList={kRelativeDifferenceLists.looseAdvices} />
                    : finalScore > kGamesNumbers.relativeDifferenceRecord
                        ? <GamesRecordResultContent finalScore={finalScore}
                                                    advicesList={kRelativeDifferenceLists.recordAdvices} />
                        : <GamesSuccessResultContent finalScore={finalScore} /> }
                <GamesResultsBottomBar
                    onRetryPressed={onRetryPressed} />
            </GamesResultsLayout>
        </div>
    );
}